export const networkMembersActionTypes = {
    'PAGE_INIT': 'NETWORK_MEMBERS_PAGE_INIT',
    'PAGE_NEXT': 'NETWORK_MEMBERS_PAGE_NEXT',
    'PAGE_PREVIOUS': 'NETWORK_MEMBERS_PAGE_PREVIOUS',
    'PAGE_REQUEST': 'NETWORK_MEMBERS_PAGE_REQUEST',
    'PAGE_SUCCESS': 'NETWORK_MEMBERS_PAGE_SUCCESS',
    'PAGE_ERROR': 'NETWORK_MEMBERS_PAGE_ERROR',
    'TOGGLE_SELECTION': 'NETWORK_MEMBERS_TOGGLE_SELECTION',
    'CLEAR_SELECTION': 'NETWORK_MEMBERS_CLEAR_SELECTION',
    'TOGGLE_ALL': 'NETWORK_MEMBERS_TOGGLE_ALL',
    'ADD_FILTER': 'NETWORK_MEMBERS_ADD_FILTER',
    'REMOVE_FILTER': 'NETWORK_ENTRIES_REMOVE_FILTER',
};
